/* eslint-disable camelcase */
import moment from 'moment-timezone';

export const stripPhoneNumber = (number) => {
  if (!number) {
    return '';
  }
  let strippedNumber = number.replace(/\s/g, '');
  strippedNumber = strippedNumber.replace(/[{()}]/g, '');
  strippedNumber = strippedNumber.replace(/-/g, '');
  return strippedNumber;
};

export const formatPhoneNumber = (input) => {
  if (!input) {
    return '';
  }

  if (input.length <= 3) {
    return `(${input})`;
  }

  let output;
  const area = input.substr(0, 3);
  const pre = input.substr(3, 3);
  const tel = input.substr(6, 4);

  if (area.length < 3) {
    output = `(${area})`;
  } else if (area.length === 3 && pre.length >= 0 && pre.length < 3) {
    output = `(${area})-${pre}`;
  } else if (area.length === 3 && pre.length === 3) {
    output = `(${area})-${pre}-${tel}`;
  }
  return output;
};

export const getNotificationDataForType = (type) => {
  const data = {
    0: {
      type: {
        new: true,
      },
      title: 'New Appointment',
      action: 'made an appointment for',
    },
    1: {
      type: {
        cancelled: true,
      },
      text: 'Cancel Appointment?',
      btnText: 'Cancel',
      title: 'Appointment Cancelled',
      action: 'cancelled an appointment for',
    },
    2: {
      type: {
        rescheduled: true,
      },
      text: 'Reschedule appointment?',
      btnText: 'Reschedule',
      title: 'Appointment Rescheduled',
      action: 'rescheduled an appointment for',
    },
  };
  return data[type];
};

export const mapNotificationForCancel = (notification) => {
  const app = { ...notification };
  app._id = notification.confirmed_appointment_id;
  return app;
};

export const mapNotificationForReschedule = (notification) => {
  const app = { ...notification };
  app._id = notification.confirmed_appointment_id;
  return app;
};


export const mapNotificationForBooking = (notification) => {
  const app = notification;
  const phone_number = stripPhoneNumber(notification.client_phone_number);
  app.client = {
    email: notification.client_email,
    first_name: notification.client_first_name,
    last_name: notification.client_last_name,
    phone_number,
  };

  return app;
};


export const hasParentWithMatchingSelector = (target, className) =>
  [...document.querySelectorAll(className)].some(el =>
    el !== target && el.contains(target));

export const getDayFromCalendarDate = date => moment(date).toISOString().split('Z')[0];

export const debounce = (fn, time) => {
  let timeout;
  /* eslint-disable-next-line */
  return function (...args) {
    const functionCall = () => fn.apply(this, args);

    clearTimeout(timeout);
    timeout = setTimeout(functionCall, time);
  };
};



// WEBPACK FOOTER //
// ./src/utils.js